export const mutations = {
  RESET: 'RESET',
  TOGGLE_GLOADING: 'TOGGLE_GLOADING',
  OPEN_POPUP: 'OPEN_POPUP',
  CLOSE_POPUP: 'CLOSE_POPUP',
  SET_SHOW_DROPDOWN: 'SET_SHOW_DROPDOWN',
};

export const actions = {
  TRACK_EVENT: 'trackEvent',
};

type ActionType = {
  tag: string;
  text: string;
  class: string;
  /**
   * action return true => close modal
   */
  action: Function;
  attrs: any;
};

type Text = {
  class: string;
  tag: string;
  text: string;
};

export type PopupType = {
  id: string | undefined;
  type: string;
  title: Text;
  content: Text;
  headerClass: string;
  bodyClass: string;
  footerClass: string;
  containerClass: string;

  actions: {
    primary: ActionType;
    secondary: ActionType;
  };
};

export type ParamType = {
  eventId: any;
  properties: any;
};
